const toSnakeCase = (str: string) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};

const convertObjectToSnakeCase = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map(item => convertObjectToSnakeCase(item));
  }
  
  if (data !== null && typeof data === 'object') {
    return Object.keys(data).reduce((acc: any, key: string) => {
      const snakeKey = toSnakeCase(key);
      acc[snakeKey] = convertObjectToSnakeCase(data[key]);
      return acc;
    }, {});
  }
  
  return data;
};

export default convertObjectToSnakeCase;
